import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-sm">关于小小影院的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/60 overflow-hidden"
            >
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                  <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">Q</span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-9">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}